import { type ProjectFilters } from "./projects.types.ts"

export const projectsSliceName = "projects"

interface BaseFilterField {
  key: keyof ProjectFilters
  label: string
  placeholder?: string
}

export type FilterField =
  | (BaseFilterField & { type?: "select" | "multiselect" })
  | (BaseFilterField & { type: "text" })
  | (BaseFilterField & { type: "daterange"; endKey: keyof ProjectFilters })

/** Every param the field owns — a range writes two, `key` being its lower bound. */
export const fieldKeys = (field: FilterField): (keyof ProjectFilters)[] =>
  field.type === "daterange" ? [field.key, field.endKey] : [field.key]

export const countActiveFilters = (
  filters: ProjectFilters,
  filterFields: FilterField[]
): number =>
  filterFields.filter((field) =>
    fieldKeys(field).some((key) => {
      const value = filters[key]
      if (Array.isArray(value)) return value.length > 0
      return value !== null && value !== undefined
    })
  ).length

// A filter value is typed as the union of every param; some fields hold text.
export const asString = (value: ProjectFilters[keyof ProjectFilters]) =>
  typeof value === "string" ? value : null
